import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import type { IncomingCallSignal } from '../../../../../store/meeting/meeting.models';

export type IncomingCallModalResult = 'dismiss' | 'answer';

export type IncomingCallModalData = {
  incomingCall: IncomingCallSignal;
  channelName: string;
};

@Component({
  selector: 'app-incoming-call-modal',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './incoming-call-modal.component.html',
  styleUrl: './incoming-call-modal.component.scss',
})
export class IncomingCallModalComponent {
  private readonly dialogRef = inject(MatDialogRef<IncomingCallModalComponent, IncomingCallModalResult>);
  protected readonly data = inject<IncomingCallModalData>(MAT_DIALOG_DATA);

  protected dismiss(): void {
    this.dialogRef.close('dismiss');
  }

  protected answer(): void {
    this.dialogRef.close('answer');
  }

  protected getModeLabel(): string {
    return this.data.incomingCall.mode === 'audio' ? 'Audio Call' : 'Video Call';
  }

  protected getCallIcon(): string {
    return this.data.incomingCall.mode === 'audio' ? 'call' : 'videocam';
  }
}
